import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-br from-teal-600 to-teal-700 text-white px-6 py-16">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          {/* Column 1 - Brand */}
          <div className="md:col-span-1">
            <img
              src="https://public.readdy.ai/ai/img_res/ea4cb5db-c970-4146-ad47-2640bdfb93d8.png"
              alt="Shifa Coaching"
              className="h-16 w-auto mb-4 brightness-0 invert"
            />
            <p className="text-sm text-teal-50 leading-relaxed mb-4">
              Compassionate, faith-based support for Muslims on their journey to recovery and healing.
            </p>
            <div className="flex items-center space-x-1 text-teal-100">
              <i className="ri-moon-line text-xl"></i>
              <span className="text-xs">Healing Through Faith</span>
            </div>
          </div>

          {/* Column 2 - Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-teal-50 hover:text-white transition-colors cursor-pointer">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-teal-50 hover:text-white transition-colors cursor-pointer">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-sm text-teal-50 hover:text-white transition-colors cursor-pointer">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/testimonials" className="text-sm text-teal-50 hover:text-white transition-colors cursor-pointer">
                  Testimonials
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-sm text-teal-50 hover:text-white transition-colors cursor-pointer">
                  FAQ
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-sm text-teal-50 hover:text-white transition-colors cursor-pointer">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 3 - Resources */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Resources</h3>
            <ul className="space-y-2">
              <li>
                <a href="#" className="text-sm text-teal-50 hover:text-white transition-colors cursor-pointer">
                  Islamic Resources
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-teal-50 hover:text-white transition-colors cursor-pointer">
                  Recovery Guide
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-teal-50 hover:text-white transition-colors cursor-pointer">
                  Privacy Policy
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-teal-50 hover:text-white transition-colors cursor-pointer">
                  Terms of Service
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-teal-50 hover:text-white transition-colors cursor-pointer">
                  Confidentiality
                </a>
              </li>
            </ul>
          </div>

          {/* Column 4 - Newsletter */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Stay Connected</h3>
            <p className="text-sm text-teal-50 mb-4">
              Subscribe for recovery tips and Islamic guidance
            </p>
            <div className="flex mb-6">
              <input
                type="email"
                placeholder="Your email"
                className="flex-1 px-4 py-2.5 bg-white/10 border border-white/20 rounded-l-full text-sm text-white placeholder-teal-200 focus:outline-none focus:border-white/40"
              />
              <button className="px-6 py-2.5 bg-white text-teal-600 rounded-r-full hover:bg-teal-50 transition-colors cursor-pointer whitespace-nowrap">
                <i className="ri-send-plane-fill"></i>
              </button>
            </div>
            <div className="flex space-x-4">
              <a href="#" className="w-10 h-10 flex items-center justify-center bg-white/10 rounded-full hover:bg-white/20 transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center bg-white/10 rounded-full hover:bg-white/20 transition-colors cursor-pointer">
                <i className="ri-instagram-line text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center bg-white/10 rounded-full hover:bg-white/20 transition-colors cursor-pointer">
                <i className="ri-youtube-fill text-lg"></i>
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/20">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-sm text-teal-50">
              © {currentYear} Shifa Coaching. All rights reserved. | Confidential & Professional
            </p>
            <a 
              href="https://readdy.ai/?ref=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-sm text-teal-50 hover:text-white transition-colors cursor-pointer"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;